var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ServiceDataBase } from "@/modules/services/models/ServiceData";
import { MapProperty, MapGetMethod, MapSetMethod } from "@/utils/mapper/ClassMapper";
var SmartAd = (function (_super) {
    __extends(SmartAd, _super);
    function SmartAd() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.filePath = '';
        _this.id = '';
        _this.isOrganization = '';
        _this.isActive = '';
        _this.position = '';
        _this.text = '';
        _this.type = '';
        _this.url = '';
        return _this;
    }
    SmartAd.prototype.setData = function (data) {
    };
    SmartAd.prototype.getData = function () {
    };
    __decorate([
        MapProperty({ from: 'FilePath' })
    ], SmartAd.prototype, "filePath", void 0);
    __decorate([
        MapProperty({ from: 'ID' })
    ], SmartAd.prototype, "id", void 0);
    __decorate([
        MapProperty({ from: 'IsAcademy' })
    ], SmartAd.prototype, "isOrganization", void 0);
    __decorate([
        MapProperty({ from: 'IsActive' })
    ], SmartAd.prototype, "isActive", void 0);
    __decorate([
        MapProperty({ from: 'Position' })
    ], SmartAd.prototype, "position", void 0);
    __decorate([
        MapProperty({ from: 'Text' })
    ], SmartAd.prototype, "text", void 0);
    __decorate([
        MapProperty({ from: 'Type' })
    ], SmartAd.prototype, "type", void 0);
    __decorate([
        MapProperty({ from: 'URL' })
    ], SmartAd.prototype, "url", void 0);
    __decorate([
        MapSetMethod()
    ], SmartAd.prototype, "setData", null);
    __decorate([
        MapGetMethod()
    ], SmartAd.prototype, "getData", null);
    return SmartAd;
}(ServiceDataBase));
export { SmartAd };



//////////////////
// WEBPACK FOOTER
// ./src/modules/documents/models/PublicDocumentSmartAd.ts
// module id = null
// module chunks = 